import type { ReactNode } from 'react';

import { cssModules } from '@skyscanner/backpack-web/bpk-react-utils';

import { NAVIGATION_ITEMS } from '../../Navigation';
import { MainContent, ContentSection } from '../MainContent';

import STYLES from './PageLayout.module.scss';

const cls = cssModules(STYLES);

export type Props = {
  components: { [key: string]: ReactNode };
};

const PageLayout = ({ components }: Props) => {
  const {
    amenities,
    goodToKnow,
    hotelDescription,
    hotelInformation,
    hotelMedia,
    hotelPrices,
    location,
    navigation,
    reviews,
    rewardPriceBanner,
  } = Object.keys(components)
    .map((key) => {
      const item = NAVIGATION_ITEMS.find(
        ({ id }: { id: string }) => id === key,
      );
      const content = components[key] ? (
        <ContentSection
          key={key}
          id={item?.anchorName}
          className={cls(`PageLayout__${key}`)}
        >
          {components[key]}
        </ContentSection>
      ) : null;
      return { [key]: content };
    })
    .reduce((result, currentValue) => Object.assign(result, currentValue), {});
  return (
    <>
      {components.breadcrumbsSectionTop}
      {hotelMedia}
      {hotelInformation}
      <MainContent>
        {navigation}
        {rewardPriceBanner}
        {hotelPrices}
        {reviews}
        {location}
        {goodToKnow}
        {hotelDescription}
        {amenities}
      </MainContent>
      <div className={cls('PageLayout__bottomSection')}>
        <MainContent>
          {components.exploreOtherOptions}
          {components.breadcrumbsSectionBottom}
        </MainContent>
      </div>
      {components.scrollTopButton}
    </>
  );
};

export default PageLayout;
